export default {
    CreateMerchant: "CreateMerchant",
    ManageSystemNotifications: "ManageSystemNotifications",
    ViewBillingReports: "ViewBillingReports",
    ViewFixReport: "ViewFixReport",
    ManageSystemRoles: "ManageSystemRoles",
    UpdateMerchant: "UpdateMerchant",
    ViewAllOffers: "ViewAllOffers",
    MonitorSystem: "MonitorSystem",
    ManageSystemConfiguration: "ManageSystemConfiguration"
}